import React from 'react';
import classNames from 'classnames';
import { Map } from 'immutable';

import './style.scss';
import { ImageFromField } from '@uncinc/react-drupal-core';
import { prependApiURLToImageStyles } from '../../../helpers/prependApiURL';

import {
  SCREEN_MEDIUM,
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  SCREEN_WIDE,
} from '../../../config/constants';

const ParagraphImage = ({ entity, className }) => {
  const classes = classNames('Paragraph ParagraphImage', className);
  const imageField = entity.getIn(['field_image', 0], Map());

  if (!imageField.get('styles')) {
    return null;
  }

  return (
    <div className={classes}>
      <ImageFromField
        className="ParagraphImage__img"
        field={prependApiURLToImageStyles(imageField)}
        imageStyles={Map({
          [SCREEN_MOBILE]: 'crop_paragraph_image_xs',
          [SCREEN_MEDIUM]: 'crop_paragraph_image_sm',
          [SCREEN_TABLET]: 'crop_paragraph_image_md',
          [SCREEN_NORMAL]: 'crop_paragraph_image_lg',
          [SCREEN_WIDE]: 'crop_paragraph_image_xl',
        })}
      />
    </div>
  );
};

export default ParagraphImage;
